import DeniedDecision from "components/card/denied-decision/DeniedDecision";
import ApplicationContainer from "components/application-container/ApplicationContainer";
import { useMarkApplicationSubmitted } from "hooks";

const DeniedDecisionPage = () => {
    useMarkApplicationSubmitted();

    return (
        <>
            <title>Declined | AAA Life</title>
            <ApplicationContainer useTitle={false} data-testid="denied-decision-page">
                <DeniedDecision />
            </ApplicationContainer>
        </>
    );
};

export default DeniedDecisionPage;
